import PageHeader from './PageHeader'
import Breadcrumb from './Breadcrumb'
import getImageUrl from './get-image-url.js'

import { useMediaQuery } from 'react-responsive'

import parse from 'html-react-parser'

import { motion } from 'framer-motion'

import clsx from 'clsx'

import AudioPlayer from 'react-h5-audio-player'
import './config.scss'

const fadeInBottom = {
  hidden: {
    opacity: 0,
    y: 80,
  },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      y: {
        duration: 1.3,
        ease: [0.165, 0.84, 0.44, 1],
        delay: i,
      },
      opacity: {
        duration: 0.3,
        delay: i,
      },
    },
  }),
}

const bounceIn = {
  hidden: { opacity: 0, y: 0 },
  visible: (i) => ({
    opacity: [0, 1, 1, 1],
    y: [0, -20, 0, 0],
    scaleY: [1, 1, 0.9, 1],
    transition: { ease: 'easeOut', delay: i },
  }),
}

const Song = (props) => {
  const isPC = useMediaQuery({
    query: '(min-width: 1024px)',
  })

  return (
    <>
      <motion.div
        variants={fadeInBottom}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.5,
        }}
        className={clsx(
          'flex items-start lg:w-[46rem] gap-[0.5em] text-[clamp(13px,calc(20vw/10.24),20px)] lg:text-[13px]',
          props.className
        )}
        custom={props.delay || 0}
      >
        <div className={clsx('flex w-[2.15625em] lg:w-[4.3125em] justify-center')}>
          <div className={clsx({ 'h-[10em]': isPC }, { 'h-[5em]': !isPC })}>
            <img
              src={props.number}
              alt=""
              className="h-full w-auto object-contain"
            />
          </div>
        </div>
        <div className="lyrics">{parse(props.lyrics)}</div>
      </motion.div>
      <style jsx>{`
        .lyrics {
          line-height: 1.93;
          font-weight: 500;
        }
        @media screen and (min-width: 1024px) {
          .lyrics {
            margin-top: -0.25em;
            margin-left: 1.5em;
            font-size: 1.875em;
          }
        }
      `}</style>
    </>
  )
}

function Kowashiro() {
  const profile = [
    {
      dt: '身長',
      dd: '250cm',
    },
    {
      dt: '体重',
      dd: '160kg',
    },
    {
      dt: '特技',
      dd: `歌うのが得意だよー♪<br />↓ここの音楽配信サービスで僕の曲が聞けるよ！<br />
        <p class="flex gap-6 py-[1.75em] subscription-banner-area">
          <a
            href="https://www.youtube.com/watch?v=lX3U16vPFk8"
            target="_blank"
            rel="noreferrer"
          >
            <img src=${getImageUrl('youtube.webp')} class="inline w-[8.625em]">
          </a>
          <a
            href="https://open.spotify.com/search/%E5%A3%8A%E5%BF%97%E9%83%8E"
            target="_blank"
            rel="noreferrer"
          >
            <img src=${getImageUrl('spotify.webp')} class="inline w-[7.375em]">
          </a>
        </p>`,
      fontSize: 'calc(30vw / 7.5)',
    },
    {
      dt: '性格',
      dd: '元気で優しい',
    },
  ]

  const isMD = useMediaQuery({
    query: '(min-width: 768px)',
  })

  const isPC = useMediaQuery({
    query: '(min-width: 1024px)',
  })

  const isLG = useMediaQuery({
    query: '(min-width: 1024px)',
  })

  const isXL = useMediaQuery({
    query: '(min-width: 1440px)',
  })

  return (
    <>
      <PageHeader
        image={getImageUrl('PROFILE.png')}
        title={'壊志郎プロフィール'}
      />
      <div className="content-area">
        <Breadcrumb
          current={'壊志郎プロフィール'}
          site_url={import.meta.env.VITE_SITE_URL}
          items={[]}
        />
      </div>
      <div className="pt-[calc(118vw/7.5)] pb-[calc(215vw/7.5)] md:pt-[114px] md:pb-[100px]">
        <motion.div
          variants={fadeInBottom}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.5,
          }}
          className="text-center"
        >
          <h2>壊志郎</h2>
          <p className="paragrah-1">こわしろう</p>
        </motion.div>
        <div className="lg:flex justify-between items-center lg:max-w-[70%] mx-auto gap-16 px-[calc(70vw/7.5)] lg:px-4">
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
          >
            <div
              className={
                isXL
                  ? 'grid justify-end relative mt-[80px]'
                  : 'relative grid mt-[calc(90vw/7.5)] lg:mt-[60px]'
              }
            >
              <img
                src={getImageUrl('profile-speech-bubble.png')}
                alt=""
                className={
                  isXL
                    ? 'w-[calc(362vw/19.2)] justify-self-end'
                    : 'w-[calc(362vw/7.5)] justify-self-end lg:w-[362px]'
                }
              />
              <img
                src={getImageUrl('profile-kowashiro.png')}
                alt=""
                className={isPC ? 'w-[calc(720vw/19.2)]' : 'mt-[calc(50vw/7.5)]'}
              />
            </div>
          </motion.div>
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.5,
            }}
            custom={0.3}
          >
            <div className="box-1 lg:mb-16">
              <dl className="profile-list">
                {profile.map((item, index) => {
                  return (
                    <div key={index}>
                      <dt>{item.dt}</dt>
                      {isPC ? (
                        <dd>{parse(item.dd)}</dd>
                      ) : (
                        <dd
                          style={
                            item.fontSize && {
                              fontSize: item.fontSize,
                            }
                          }
                        >
                          {parse(item.dd)}
                        </dd>
                      )}
                    </div>
                  )
                })}
              </dl>
            </div>
          </motion.div>
        </div>
      </div>
      <div className="section-2">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.5,
          }}
          className={clsx(
            ' text-[clamp(4.5px,calc(16vw/19.2),16px)]',
            isMD && 'flex justify-center gap-4',
            !isMD && 'grid'
          )}
        >
          <motion.div
            variants={fadeInBottom}
            custom={0.3}
            className={clsx(!isMD && 'col-start-1 row-start-1')}
          >
            <div
              style={{
                backgroundImage: `url(${getImageUrl('profile-theme-song-score.webp')})`,
              }}
              className={clsx(
                'bg-no-repeat bg-contain bg-[50%_0] mt-[3em] h-[6.25rem] md:h-full',
                isMD && 'w-[76.768em] ml-[6.5rem]'
              )}
            >
              <div className={clsx('flex justify-center items-end', !isMD && 'ml-[-1.75rem]')}>
                <motion.div
                  variants={bounceIn}
                  custom={0.5}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-01.webp')}
                    className="relative left-[3.75em] top-[-4.25em] w-[7.06em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={0.7}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-02.webp')}
                    className="relative left-[3.5em] top-[-3em] w-[5em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={0.9}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-03.webp')}
                    className="relative left-[3.5em] top-[-2em] w-[5em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={1.1}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-04.webp')}
                    className="relative left-[3.5em] top-[0.75em] w-[7.313em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={1.3}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-05.webp')}
                    className="relative left-[3.5em] top-[-1em] w-[5em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={1.5}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-06.webp')}
                    className="relative left-[3.5em] top-[-0.75em] w-[6.813em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={1.7}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-07.webp')}
                    className="relative left-[3em] top-[-4em] w-[5.875em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={1.9}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-08.webp')}
                    className="relative left-[3em] top-[-5.25em] w-[5em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={2.1}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-09.webp')}
                    className="relative left-[3em] top-[-4.75em] w-[7.375em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={2.3}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-10.webp')}
                    className="relative left-[2.5em] top-[-4.5em] w-[5em]"
                  />
                </motion.div>
                <motion.div
                  variants={bounceIn}
                  custom={2.5}
                >
                  <img
                    src={getImageUrl('profile-theme-song-letter-11.webp')}
                    className="relative left-[2.5em] top-[-2.5em] w-[5em]"
                  />
                </motion.div>
              </div>
            </div>
          </motion.div>
          <motion.div
            variants={fadeInBottom}
            className={clsx(!isMD && 'col-start-1 row-start-1')}
          >
            <img
              src={getImageUrl('profile-theme-song-kowashiro.webp')}
              className={clsx(
                isMD && 'w-[19.708em]',
                !isMD && 'mt-[3rem] mr-[2.188rem] ml-auto w-[4.57rem]'
              )}
            />
          </motion.div>
        </motion.div>
        <motion.div
          variants={fadeInBottom}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.5,
          }}
        >
          <h2 className="theme-song-title">
            ぼく壊志郎♪
            <span className="ruby">こわしろう</span>
          </h2>
        </motion.div>
        <motion.div
          variants={fadeInBottom}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.5,
          }}
        >
          <p className="paragrah-2">
            <span className="">歌：</span>
            <span className="md:text-[3.75rem] text-[1.875rem] font-medium">michi</span>
            {!isMD && <br />}
            <span className={clsx('md:ml-[3.5rem]', !isMD && ' inline-flex pt-[1rem]')}>
              作詞・作曲：野々田万照
            </span>
          </p>
        </motion.div>
        <div className="content-area">
          <div className=" mt-[1.75rem] lg:mt-[4rem]">
            <div className="flex justify-center">
              <motion.div
                variants={fadeInBottom}
                initial="hidden"
                whileInView="visible"
                viewport={{
                  once: true,
                  amount: 0.5,
                }}
              >
                <AudioPlayer
                  src={getImageUrl('boku-kowashiro.wav')}
                  className={clsx('max-w-[90vw] text-[16px] lg:text-[13px]', {
                    'w-[66.875em] rounded-[30px] px-[3.68em] py-[3em]': isLG,
                    'w-[19.063em] rounded-[15px] px-[1rem] py-[0.65em]': !isLG,
                  })}
                  customAdditionalControls={[]}
                />
              </motion.div>
            </div>
          </div>
          <div className="w-fit mx-auto mt-[6rem] lg:mt-[9rem] space-y-[64px]">
            <Song
              number={getImageUrl('profile-number-1.png')}
              lyrics={`
            ぼく壊志郎！<br />
            優しくて力持ち　いつでも笑顔で<br />
            自由自在の赤い腕　何でも掴むよ<br />
            くりくりお目目で　横浜の人気者さ<br />
            今日も明日もどこかで　腕振ってます<br />
            怖くないよ　壊すんだよ<br />
            埃にまみれても　それが誇りさ！<br />
            U～Yah！<br />
            ぼくが壊すには新しい　そう、夢を造る為<br />
            前向いて進もう　この街の為に<br />
            ぼくが壊すのは新しい　そう、未来造る為<br />
            くじけずに進もう　みんなの為に<br />
            ぼく壊志郎
            `}
            />
            <Song
              number={getImageUrl('profile-number-2.png')}
              lyrics={`
            ぼく壊志郎！<br />
            青色ヘルメット　黒い靴はキャタピラ<br />
            歩くのは遅いけど　どこでも行けるよ<br />
            安全第一で　陽気な仲間と<br />
            今日も明日もどこかで　汗かいてます<br />
            怖くないよ　壊すんだよ<br />
            汗にまみれてるけど　焦らず進め！<br />
            U～Yah！<br />
            ぼくが壊すのは新しい　そう、明日を造る為<br />
            どこまでも進もう　チカラ合わせて<br />
            ぼくが壊すのは新しい　そう、絆造る為<br />
            上向いて進もう　希望と共に<br />
            ぼく壊志郎
            `}
            />
            <Song
              number={getImageUrl('profile-number-3.png')}
              lyrics={`
            U～Yah！<br />
            ぼくが壊すのは新しい　そう、夢を造る為<br />
            前向いて進もう　この街の為に<br />
            ぼくが壊すのは新しい　そう、未来造る為<br />
            くじけずに進もう　みんなの為に<br />
            ぼく壊志郎<br />
            <br />
            ぼく壊志郎
            `}
            />
          </div>
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.25,
            }}
          >
            <img
              src={getImageUrl('profile-kowashiro-back.jpg')}
              alt=""
              className="mx-auto w-[43.75rem] mt-[80px] lg:mt-[12.5rem]"
            />
            <p className="text-center font-bold mt-[1.75rem] text-[calc(30vw/7.5)] lg:text-[1.875rem]">
              背中で語る男「壊志郎」
            </p>
          </motion.div>
        </div>
      </div>
      <style jsx>{`
        h2 {
          text-align: center;
          font: normal normal bold calc(80vw / 7.5) Noto Sans JP;
          color: #2964b6;
        }
        .paragrah-1 {
          text-align: center;
          font: normal normal bold 20px/20px Noto Sans JP;
          margin-top: 4px;
        }
        .box-1 {
          border: 6px solid #2964b6;
          border-radius: 40px;
          margin-top: 60px;
          height: fit-content;
        }
        .profile-list {
          padding: calc(82vw / 7.5) calc(28vw / 7.5);
          font-size: calc(35vw / 7.5);
        }
        .profile-list div {
          padding: calc(16vw / 7.5) 0;
          border-bottom: 2px solid #2964b6;
          display: grid;
          grid-template-columns: auto 1fr;
          gap: calc(40vw / 7.5);
        }
        .profile-list dt {
          text-align: center;
          color: #2964b6;
          font-weight: bold;
          font-size: calc(36vw / 7.5);
        }
        .profile-list dd {
          font-weight: 500;
        }
        .section-2 {
          background: #f4fbff 0% 0% no-repeat padding-box;
          padding: calc(112vw / 7.5) 0;
        }
        .theme-song-title {
          max-width: fit-content;
          margin: 1.375rem auto 0;
          position: relative;
        }
        .ruby {
          display: none;
        }
        .paragrah-2 {
          margin-top: 1.375rem;
          text-align: center;
        }
        @media screen and (min-width: 1024px) {
          h2 {
            text-align: center;
            font: normal normal bold 80px/80px Noto Sans JP;
            color: #2964b6;
          }
          .paragrah-1 {
            text-align: center;
            font: normal normal bold 20px/20px Noto Sans JP;
            margin-top: 14px;
          }
          .box-1 {
            border: 6px solid #2964b6;
            border-radius: 40px;
            margin-top: 60px;
          }
          .profile-list {
            padding: calc(40vw / 19.2) calc(60vw / 19.2);
          }
          .profile-list div {
            padding-bottom: 8px;
            border-bottom: 2px solid #2964b6;
            display: grid;
            grid-template-columns: auto 1fr;
            align-items: center;
          }
          .profile-list dt {
            text-align: center;
            font: normal normal bold min(calc(36vw / 19.2), 36px) Noto Sans JP;
            color: #2964b6;
          }
          .profile-list dd {
            font-size: min(calc(24vw / 14.4), 24px);
            font-weight: 500;
          }
          .section-2 {
            background: #f4fbff 0% 0% no-repeat padding-box;
            padding-inline: 0.75rem;
          }
          .theme-song-title {
            max-width: fit-content;
            margin: 40px auto 0;
            position: relative;
          }
          .ruby {
            text-align: center;
            font: normal normal bold 20px/58px Noto Sans JP;
            color: rgb(0, 0, 0);
            position: absolute;
            top: -40px;
            left: 230px;
            display: block;
          }
          .paragrah-2 {
            text-align: center;
            font-size: 1.9rem;
            margin-top: 1rem;
          }
        }
      `}</style>
      <style
        jsx
        global
      >{`
        .subscription-banner-area {
          font-size: clamp(11px, calc(16vw / 19.2), 16px);
        }
      `}</style>
    </>
  )
}

export default Kowashiro
